import React, { useState, useEffect } from 'react'
import {connect} from 'react-redux';
import { setSelectedPlan, setCurrentStep, setIsReturningOldDevice } from '../OrganizationPortalSlice';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import {Input} from 'reactstrap';

function ProductDetailsPopUp({product,setShowPopup,setSelectedPlan,selectedPlan,setError,userDetails,setIsReturningOldDevice,orgDetails}) {

  const [selectedItemId, setSelectedItemId] = useState(product.models[0].itemId);
  const [returningOldDeviceValue, setReturningOldDeviceValue] = useState('');
  const [returningOldDeviceError, setReturningOldDeviceError] = useState('');

  useEffect(() => {
    setReturningOldDeviceValue('');
    setReturningOldDeviceError('');
  }, [product]);

  const handleReturningOldDeviceChange = (e) => {
    setReturningOldDeviceValue(e.target.value);
    setReturningOldDeviceError('');
  };

  const scrollToButton = () => {
    const footerButtons = document.querySelector('.Footer_Buttons');
    footerButtons?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  };

 const selectProduct=()=>{
    if (userDetails.actionType === 'upgrade' && returningOldDeviceValue === '' && orgDetails.allowReturningOldDevice) {
      setReturningOldDeviceError('בחר אפשרות');
      return;
    }

    if (userDetails.actionType === 'upgrade') {
      setIsReturningOldDevice(returningOldDeviceValue === 'true');
    }

    setShowPopup(false);
    requestAnimationFrame(scrollToButton);
    setError("")
    setSelectedPlan({...selectedPlan,
      model:{...selectedPlan.model,
        name: product.modelName,
        price:product.price,
        storage:product.storage,
        itemId:selectedItemId ,
        color: product.models.find(m=>m.itemId==selectedItemId).color}
    });
 }

  return (
    <div className="product-details-popup ">
        <div >
          <span className='M_Title d-block'>{product.modelName}</span>
          <span className='S_Title'>{product.storage+"GB"}</span>
        </div>
        <div className='selectColor'>
          <p className='M_SubTitle'> על איזה צבע הולכים? </p>
      <div className='select-input'>
        <label className={`has-float-label`}>
          <Input type='select' value={selectedItemId}  onChange={(e) =>{setSelectedItemId(e.target.value)}}  placeholder='צבע' >
            {product.models.map((item) => {
              return (
                <option key={item['itemId']} value={item['itemId']}>
                  {item['color']}
                </option>
              );
            })}
        </Input>
      </label>
    </div>

        </div>

        {userDetails.actionType === 'upgrade' && orgDetails.allowReturningOldDevice && (
          <div>
            <p className='M_SubTitle'> מחזיר מכשיר ישן </p>
            <div className='select-input'>
              <label className={`has-float-label`}>
                <Input type='select' value={returningOldDeviceValue} onChange={handleReturningOldDeviceChange}>
                <option value=''>בחר אפשרות</option>
                  <option value='true'>כן</option>
                  <option value='false'>לא</option>
                </Input>
              </label>
            </div>
          </div>
        )}
          {/* <a className='specification' href='#' onClick={() => prepareUrl(product.specificationLink, EpiContext)}>
              לצפיה במפרט המכשיר
          </a> */}
        {/* <p className='S_SubTitle price'>&#8362;{product.price}</p> */}

          <BtnSubmit
               text={'בחירה'}
               onclick={()=>selectProduct()}
          />
    </div>
  );
}


const mapStateToProps = (state) => ({
  userDetails:state.organizationPortal.userDetails,
  selectedPlan:state.organizationPortal.userDetails.selectedPlan,
  orgDetails: state.organizationPortal.orgDetails,
});

const mapDispatchToProps = {
  setSelectedPlan,
  setCurrentStep,
  setIsReturningOldDevice,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductDetailsPopUp);

